export function nl2br(text, reg = /(\n|\r)/g) {
	return text && text !== null ? text.split(reg).join('<br/>') : text;
}

export default { nl2br };
